<template>
  <el-tooltip class="item" effect="dark" content="按经纪人名字查询" placement="top">
    <el-select
            v-model="data"
            value-key="name"
            v-bind="$attrs"
            filterable
            remote
            :remote-method="search"
            :loading="loading"
            @change="onChange"
            @clear="onClean"
            ref="factorAutoComplete"
            placeholder="请输入经纪人名字"
    >
        <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.name"
                :value="item.id">
        </el-option>
    </el-select>
  </el-tooltip>
</template>
<script>
    import { searchAgentList } from '@/service/customer'
    // 目前不支持多选
    export default{
        props: {
            siteId: {
                type: Number,
            },
            value: [Number, String],
            limit: {
                type: Number,
                default: 20
            },
            status: {
                type: Number,
                default: null
            },
            callback: Function,
            initChooseFirst: {
                type: Boolean,
                default: false
            },
            dept_id: [Number, String],
        },
        data() {
            return {
                data: null,
                loading: false,
                options: [],
                searchTimeOutHandle: null,
            }
        },
        watch: {
            value(val) {
                if (val !== this.data) {
                    this.$emit('input', this.value)
                    this.search()
                }
            },
            siteId(newV,oldV){
                if(newV){
                   this.search()
               }
            },
            dept_id(newV,oldV){
               if(newV){
                   this.search()
               }
            }
        },
        methods: {
            search(query, isInit = false) {
                this.loading = true
                clearTimeout(this.searchTimeOutHandle)
                let conditions = {
                     site_id:this.siteId
                }
                if(this.dept_id !== null ){
                     conditions.dept_id = this.dept_id
                }

                if (!!query) {
                   conditions.name = query
                }

                let that = this
                let timeout = isInit ? 0 : 300
                this.searchTimeOutHandle = setTimeout(() => {
                    searchAgentList(conditions).then(response => {
                        that.loading = false
                        that.options = response
                        that.data = null
                        if (response.length > 0) {
                            if (!!that.value) {
                                that.options.forEach(item => {
                                    if (item.id === that.value) {
                                        that.data = that.value
                                    }
                                })
                            } else if (that.initChooseFirst) {
                                that.data = response[0].id
                            }
                        }
                        that.onChange()
                        if (isInit) {
                            that.$emit('created', that.data)
                        }
                    }).catch(err => {
                        this.isLoading = false;
                        const message = err.context.length ? err.context[0] : err.message;
                        this.$message({
                        type: "error",
                        message: message
                        });

                        that.loading = false
                    })
                }, timeout)
            },
            onChange(item) {
                this.$emit('input', this.data)
                this.callback && this.callback(item)
            },
            onClean() {
                // this.options = []
                this.data = null
                this.$emit('input', '')
            }
        }
    }
</script>
